// src/features/services/media/api/mediaApi.ts
import { bff } from '@/lib/http/bff';

export interface YoutubeMp3Request {
  url: string;
}

export interface YoutubeSplitRequest {
  url: string;
}

export interface YoutubeMp3AcceptedResponse {
  ok: boolean;
  status: 'accepted';
  jobId: number | string;
  run_id: number | string;
  eventsUrl: string;
  latestUrl: string;
  published?: boolean;
  topic?: string;
  error?: string;
  detail?: string;
}

export interface SplitAudioRequest { bucketUrl: string }
export type SplitAudioAcceptedResponse = YoutubeMp3AcceptedResponse;

// Access env safely without using import.meta (silences CRA warnings)
const META_ENV: any = (typeof globalThis !== 'undefined' && (globalThis as any).process && (globalThis as any).process.env) ? (globalThis as any).process.env : {};
const YT_TIMEOUT_MS = Number(META_ENV.VITE_MEDIA_YT_TIMEOUT_MS || (globalThis as any)?.MEDIA_YT_TIMEOUT_MS || 60000);

export function postYoutubeMp3(body: YoutubeMp3Request): Promise<YoutubeMp3AcceptedResponse> {
  // Long-running conversion: server returns 202 with job metadata
  return bff.post<YoutubeMp3AcceptedResponse>('/services/media/youtube-mp3', body, { timeoutMs: YT_TIMEOUT_MS });
}

export function postSplitAudio(body: SplitAudioRequest): Promise<SplitAudioAcceptedResponse> {
  return bff.post<SplitAudioAcceptedResponse>('/services/media/split-audio', body);
}

export function postYoutubeSplit(body: YoutubeSplitRequest): Promise<YoutubeMp3AcceptedResponse> {
  return bff.post<YoutubeMp3AcceptedResponse>('/services/media/youtube-split', body, { timeoutMs: YT_TIMEOUT_MS });
}

// (Job polling moved to features/system/jobs)
